/* eslint-disable @typescript-eslint/camelcase */
import React, { useCallback, Dispatch, useRef, useMemo, useState, useEffect } from 'react';
import { Form } from '@unform/web';
import { FiArrowRight, FiArrowLeft, FiMail } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import axios from 'axios';
import pagarme from 'pagarme';
import { type } from 'os';
import { Link, useParams } from 'react-router-dom';
import api from '../../../../services/api';
import MaskedInput from '../../../../components/Forms/MaskedInput';
import Input from '../../../../components/Forms/Input';
import Button from '../../../../components/Forms/Button';
import SelectSimple from '../../../../components/Forms/SelectSimple';

import { eventName, gateKey } from '../../../../config';
import imgBoleto from '../../../../assets/barcode.png';

import { AnimatedDiv } from '../../styles';
import { Content } from './styles';
import { useModal } from '../../../../hooks/Modal';
import { useToast } from '../../../../hooks/Toast';

import Whatsapp from '../../../../components/Whatsapp';

import { BuyContext } from '../../index';
import Loader from '../../../../components/Loader';
import format from '../../../../utils/format';
import {
  ResponseMessage,
  IResponseMessage,
} from '../../../../components/ResponseMessage';

import UpdateUserContainer from '../../../../components/UserUpdateComponent';
import { useAuth } from '../../../../hooks/Auth';
import { useLanguage } from '../../../../hooks/Language';
import { FaCreditCard, FaReceipt } from 'react-icons/fa';
import AtualizarCadastroContainer from '../AtualizarCadastro';
import { uuid } from 'uuidv4';

interface IComponentProps {
  step: number[];
  setStep: Dispatch<React.SetStateAction<number[]>>;
  buyContext: BuyContext;
  setBuyContext: Dispatch<React.SetStateAction<BuyContext>>;
}

interface ICardProps {
  id?: string;
  card_holder_name: string;
  card_expiration_date: string;
  card_number: string;
  card_cvv: string;
  installments?: number;
  document_type: string;
}

interface IInstallment {
  label: string;
  value: string;
}

interface IParams {
  product_hash : string;
}

const PaymentMethod: React.FC = () => {

  const [buyContext,setBuyContext] = useState<Record<string,any>>({});
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  const [ready, setReady] = useState(false);
  const formRef = useRef<FormHandles>(null);

  const[productNotFound,setProductNotFound] = useState(false);

  const {product_hash} = useParams<IParams>();

  const { addToast } = useToast();
  const { addModal } = useModal();

  const [responseMessage, setResponseMessage] = useState(
    {} as IResponseMessage,
  );

    const {translate} = useLanguage();

  const {user} = useAuth();

  const load = async(hash) => {

    if(user){

   
  try{
    const response = await api.get(`/product/${product_hash}`);

    if(!response || !response?.data?.id){
     setProductNotFound(true);
      return;
    }

    const product = response?.data;

    if(!product){
      setProductNotFound(true);
    setLoading(false);
   
    addToast({type:"error", title: "Produto não identificado", description:'Este produto parece não estar mais ativo'});
    return;
    }


    setLoading(false);
    setReady(true);
    setBuyContext({ products : [product], amount : product.price});
  } 
  catch (err) {
    setProductNotFound(true);
    setLoading(false);
   
    addToast({type:"error", title: "Produto não identificado", description:'Este produto parece não estar mais ativo'});
    return;
    }

}
  }

  useEffect(() => {

    if(!product_hash){
       window.location.href = '/inscricao';
       return;
    }

   
    load(product_hash);
    setLoading(false);

  },[product_hash])


  const handleChangePaymentMethod = useCallback(
    id => {
      setBuyContext({ ...buyContext, billing: { paymentMethod: id } });
    },
    [buyContext],
  );

  const installments = useCallback(() : Array<IInstallment> => {


    if(buyContext && buyContext.billing && buyContext.billing.paymentMethod === 'boleto'){
      return [{label : '1x', value : '1'}];
    }

    if(buyContext && buyContext.billing && buyContext.billing.paymentMethod === 'credit_card'){
    const installment : Array<IInstallment> = [];
    for (let x = 1; x <= 5; x += 1) {
      const amount = buyContext.amount;
      if(amount && (amount / x)) {
      installment.push({
        label: `${x}X ${format(
          parseInt((amount / x)?.toString(), 10),
        )}`,
        value: x?.toString(),
      });}
    }

    
    return installment;}

    else{
      return [{label : '1x', value : '1'}]
    }
  }, [buyContext]);

  const handleFinishCreditCard = useCallback(
    async (card: ICardProps) => {
      setLoading(true);
      const cardValidations = await pagarme.validate({ card });

      if (!cardValidations.card.card_number) {
        addModal({
          title: translate('Cartão inválido'),
          content: <>{translate('Verifique o número do seu cartão')}</>,
        });
        setLoading(false);
        return false;
      }
      

      await pagarme.client
        .connect({ encryption_key: gateKey })
        .then(async (client: Record<string, any>) => {
          const card_hash = await client.security.encrypt(card);

          return card_hash;
        })
        .then(async (card_hash: string) => {
          if (!card_hash) {
            setLoading(false);
            return false;
          }

          const context = {
            ...buyContext,
            billing: {
              paymentMethod: 'credit_card',
              credit_card_hash: card_hash,
              installments: card.installments,
              document_type: card.document_type,
            },
          };

          await api
            .post(`/payment`, {
              ...context,
            })
            .then(response => {
              const { data } = response;

              if (data && data.status === 'success') {
                return window.location.href = `/payment/success/${data.hash}`;
              } else {
                addModal({ title: 'Erro', content: data.message, key: '1' });
              }
              setLoading(false);
            })
            .catch(err => {
              addToast({
                title: translate('Erro'),
                description: translate('Erro ao efetuar pagamento'),
                type: 'error',
              });
              setLoading(false);
              return false;
            });
        });
    },
    [addToast, buyContext],
  );

  const handleFinishBoleto = useCallback(
    async dataForm => {
      setLoading(true);

      const context = {
        ...buyContext,
        billing: {
          paymentMethod: 'boleto',
          document_type: dataForm.document_type,
        },
      };


      await api
        .post(`/payment`, {
          ...context,
        })
        .then(response => {
          const { data } = response;
          if (data && data.status === 'success') {
            return window.location.href = `/payment/success/${data.hash}`;
          } else {
            addModal({ title: 'Erro', content: data.message, key: '1' });
          }

          setLoading(false);
        })
        .catch(err => {
           addToast({
                title: translate('Erro'),
                description: translate('Erro ao efetuar pagamento'),
                type: 'error',
              });
          setLoading(false);
          return false;
        });
    },
    [addToast, buyContext],
  );


  if(update){
    return <AnimatedDiv visible={true}>
      <AtualizarCadastroContainer/>
    </AnimatedDiv>
  }

  if(!user){
    return         <div className="onlineMessage" style={{display:'flex', width:'auto', maxWidth: '400px',margin: '0px auto', flexDirection:'column',border: '2px solid #555', borderRadius: '20px',padding: '20px',marginTop:'100px', alignItems:'center', justifyContent: 'center'}}>
         
    <h2 className="defaultMarked"><div/>{translate('Falha ao completar ação')}</h2>
    <p style={{color: '#555', textAlign: 'center',marginTop: '20px'}}>
      {translate(
        'Você precisa estar logado para finalizar a incrição.',
      )}
    </p><br/><br/>
    <Link to="/planos">
      <button className="shadowGreyButton" type="button">
        {' '}
        {translate('Voltar')}
      </button>
    </Link>
  </div>
  }

  if(productNotFound){
   return <div className="onlineMessage" style={{display:'flex', width:'auto', maxWidth: '400px',margin: '0px auto', flexDirection:'column',border: '2px solid #555', borderRadius: '20px',padding: '20px',marginTop:'100px', alignItems:'center', justifyContent: 'center'}}>
         
    <h2 className="defaultMarked">{translate('Ingresso não encontrado')}</h2>
    <p style={{color: '#555', textAlign: 'center',marginTop: '20px'}}>
      {translate(
        'Verifique se este ingresso ainda está disponível.',
      )}
    </p><br/><br/>
    <Link to="/planos">
      <button className="shadowGreyButton" type="button">
        {' '}
        {translate('Voltar')}
      </button>
    </Link>
  </div>
  }

  return (
    <>
      {loading && <Loader message={`${translate('Carregando')}...`} />}
     {ready && <AnimatedDiv visible={true}>
        {responseMessage.active === true && (
          <ResponseMessage
            active
            type={responseMessage.type}
            title={responseMessage.title}
            description={responseMessage.description}
          />
        )}
        {responseMessage.active !== true && (
          <>
            <Content>
             
              <Whatsapp
                text={`${translate('Olá, estou finalizando a inscrição no')} ${eventName}`}
                message={translate('Suporte Técnico')}
              />
              <Button
                type="button"
                onClick={() =>
                  addModal({
                    title: '',
                    content: <UpdateUserContainer />,
                    key: 'userUpdateForm',
                  })}
              >
                {translate('Revisar meu Cadastro')}
              </Button>

              <aside style={{display:'flex', flexDirection:'column', alignItems: 'center'}}>
                <h2 style={{color:'#fff', margin: '30px 0px'}}>Selecione a forma de pagamento</h2>
                {user  && <button  style={{display:'flex', alignItems:'center', width:'200px', flexDirection:'row', margin:'10px', justifyContent:'flex-start'}}
                  className={
                    buyContext?.billing?.paymentMethod === 'boleto'
                      ? 'active'
                      : ''
                  }
                  type="button"
                  onClick={() => handleChangePaymentMethod('boleto')}
                >
                  <input
                    checked={buyContext?.billing?.paymentMethod === 'boleto'}
                    name="payment_method"
                    value="boleto"
                    type="checkbox"
                  />
                <FaReceipt size={30} style={{marginRight:'10px'}}/><p>{translate('Boleto')}</p>
                  
                </button>}
                <button
                style={{display:'flex', alignItems:'center', flexDirection:'row', margin:'10px',width:'200px', justifyContent:'flex-start'}}
                  className={
                    buyContext?.billing?.paymentMethod === 'credit_card'
                      ? 'active'
                      : ''
                  }
                  type="button"
                  onClick={() => handleChangePaymentMethod('credit_card')}
                >
                  <input
                    checked={
                      buyContext?.billing?.paymentMethod === 'credit_card'
                    }
                    name="payment_method"
                    value="credit_card"
                    type="checkbox"
                  />
                  <FaCreditCard size={30} style={{marginRight:'10px'}}/><p>{translate('Cartão de Crédito')}</p>
                  
                </button>
              </aside>
            </Content>
            <Content>
              <aside>
                {buyContext?.billing?.paymentMethod === 'credit_card' && (
                  <Form className="form"
                    ref={formRef}
                    initialData={{ installments: '1'}}
                    onSubmit={handleFinishCreditCard}
                  >
                    <SelectSimple
                      options={[
                        { value: user.country === 'BR' ? 'cpf' : 'other', label: translate('Pessoa Física') },
                        {
                          value: 'cnpj',
                          label: translate('Entidade / Pessoa Jurídica'),
                        },
                      ]}
                      name="document_type"
                      formRef={formRef}
                      label={translate('Emitir como')}
                    />
                    <Input name="card_number" placeholder={translate('Número do Cartão')} />
                    <Input
                      name="card_holder_name"
                      placeholder={translate('Nome no Cartão')}
                    />
                    <MaskedInput
                      mask="99/99"
                      name="card_expiration_date"
                      placeholder={translate('Validade')}
                    />
                    <Input name="card_cvv" placeholder="CVV" />
                    <SelectSimple
                      name="installments"
                      label={translate('Parcelas')}
                      options={installments()}
                    />

                    <Button type="submit">
                      {translate('Finalizar Compra')}
                      <FiArrowRight />
                    </Button>
                 
                  </Form>
                )}

                {buyContext?.billing?.paymentMethod === 'boleto' && (
                  <Form className="form"
                    ref={formRef}
                    onSubmit={handleFinishBoleto}
                    initialData={{ document_type: 'cpf' }}
                  >
                    <SelectSimple
                      options={[
                        { value: 'cpf', label: translate('Pessoa Física') },
                        {
                          value: 'cnpj',
                          label: translate('Entidade / Pessoa Jurídica'),
                        },
                      ]}
                      name="document_type"
                      formRef={formRef}
                      label={translate('Emitir como')}
                    />
                    <Button type="submit">
                    {translate('Finalizar Compra')}
                      <FiArrowRight />
                    </Button>
                  
                  </Form>
                )}
              </aside>
            </Content>
          </>
        )}
      </AnimatedDiv>}
    </>
  );
};

export default PaymentMethod;
